import { Injectable } from '@angular/core';
import constantURL from '../../../../shared/constantURL';
import { BaseLoggedInPostService } from '../../../../shared/services/base-logged-in-post.service';

@Injectable({
  providedIn: 'root'
})
export class AddBankAccountService extends BaseLoggedInPostService {
  _path = constantURL.bankAccount.addAccount;

  processResult(account: any) {
    const { Branch, ...rest } = account;
    if(Branch && Branch.Bank){
      return {
        bank_name: Branch.Bank.bank_name,
        branch_name: Branch.english_branch_name,
        arabic_branch_name: Branch.arabic_branch_name,
        arabic_bank_name: Branch.Bank.arabic_bank_name,
        ...rest
      };
    }
    return account;
  }
}
